import React, { useEffect } from "react";
import { Button, Table, TableHead, TableBody, Box } from "@mui/material";
import FullPageLayout from "../../components/FullPageLayout";
import PropTypes from "prop-types";
import MessagesHead from "./MessagesHead";
import MessagesRow from "./MessagesRow";

function DeleteButton(props) {
  return (
    <Box my={4}>
      <Button
        color="primary"
        variant="contained"
        disabled={props.disabled}
        onClick={props.onClick}
      >
        Delete Selected Messages
      </Button>
    </Box>
  );
}

function Messages(props) {
  const { data, onRowExpand, onDelete, onSort } = props;
  const [selection, setSelection] = React.useState([]);
  const [expansion, setExpansion] = React.useState([]);
  const [sorting, setSorting] = React.useState({});

  const changeRowSelection = (id, isSelected = false) => {
    if (isSelected) {
      setSelection([...selection, id]);
    } else {
      setSelection(
        selection.filter(item => {
          return item !== id;
        })
      );
    }
  };

  const changeRowExpansion = (row, isExpanded = false) => {
    if (isExpanded) {
      setExpansion([...expansion, row.id]);
    } else {
      setExpansion(
        expansion.filter(item => {
          return item !== row.id;
        })
      );
    }
  };

  const changeSorting = params => {
    setSorting(params);
    onSort(params);
  };

  useEffect(() => {
    setSelection(selection.filter(item => data.find(obj => obj.id === item)));
    setExpansion(expansion.filter(item => data.find(obj => obj.id === item)));
  }, [data]);

  return (
    <FullPageLayout title="Messages">
      <DeleteButton
        disabled={selection.length === 0}
        onClick={() => onDelete(selection, sorting)}
      />
      <Table>
        <TableHead>
          <MessagesHead onSort={changeSorting} />
        </TableHead>
        <TableBody>
          {data.map((row, idx) => (
            <MessagesRow
              checked={selection.includes(row.id)}
              expanded={expansion.includes(row.id)}
              key={idx}
              row={row}
              onExpandClick={changeRowExpansion}
              onExpand={onRowExpand}
              onCheckboxClick={changeRowSelection}
            />
          ))}
        </TableBody>
      </Table>
    </FullPageLayout>
  );
}

Messages.propTypes = {
  data: PropTypes.arrayOf(PropTypes.any).isRequired,
  onRowExpand: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onSort: PropTypes.func
};

export default Messages;
